<div [formGroup]="formGroup">
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Column</mat-label>
    <mat-select formControlName="column">
      <mat-option *ngFor="let column of state.columns; trackBy: trackByColumn" [value]="column.column">
        <y42-column-type-icon *ngIf="column.type" [type]="column.type"></y42-column-type-icon>
        {{ column.column }}
      </mat-option>
      <mat-select-trigger>
        <ng-container *ngIf="state.selectedColumnType as type">
          <y42-column-type-icon [type]="type"></y42-column-type-icon>
        </ng-container>
        {{ formGroup.controls.column.value }}
      </mat-select-trigger>
    </mat-select>
    <mat-error *ngIf="formGroup.controls.column.errors?.required">Please select a column</mat-error>
  </mat-form-field>

  <div *ngIf="state.columnForOperationInput">
    <y42-operation-input
      [column]="state.columnForOperationInput"
      formControlName="operations"
      [visibilityConfig]="visibilityConfig"
    ></y42-operation-input>
  </div>

  <y42-threshold-form-part
    [failedByConditionControl]="thresholdFormArguments.rowsFailedByConditionControl"
    [failedConditionControl]="thresholdFormArguments.rowsFailedConditionControl"
  ></y42-threshold-form-part>
</div>
